<ng-template ngFor [ngForOf]="parts" let-part let-isOdd="odd"><span *ngIf="isOdd; else even" [class]="highlightClass">{{part}}</span><ng-template #even>{{part}}</ng-template></ng-template>


// WEBPACK FOOTER //
// ./node_modules/@ng-bootstrap/ng-bootstrap/ng-bootstrap.d.ts.NgbHighlight.html